import { tUnchecked } from '@glow/language'
import i18next from 'i18next'

const separator = ' - '

export function generateFullTitle(pageTitle?: string) {
  if (!pageTitle) return i18next.t('application.title.siteName')
  else if (pageTitle === 'recipient') return 'Track your delivery from Bring'
  return i18next.t('application.title.siteName') + separator + tUnchecked(`application.title.${pageTitle}`)
}
